import { useEffect, useRef } from "react";

// docMentis udoc-viewer ships modern ESM (class fields, import.meta.url for
// WASM resolution) that react-scripts 4's webpack 4 cannot bundle. We load it
// at runtime from jsDelivr's /+esm path, which returns a browser-ready ESM
// bundle with the WASM URL pointing back at the CDN.
const UDOC_CDN_URL = "https://cdn.jsdelivr.net/npm/@docmentis/udoc-viewer@0.6.36/+esm";

const UDocViewer = ({ src, onError, onLoad, style }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    let client;
    let viewer;
    let cancelled = false;

    const start = async () => {
      try {
        const mod = await import(/* webpackIgnore: true */ UDOC_CDN_URL);
        const UDocClient = mod.UDocClient || mod.default?.UDocClient;
        if (!UDocClient) throw new Error("UDocClient export not found");
        if (cancelled) return;

        client = await UDocClient.create();
        if (cancelled) return;

        viewer = await client.createViewer({ container: containerRef.current });
        if (cancelled) return;

        await viewer.load(src);
        if (cancelled) return;

        if (onLoad) onLoad();
      } catch (err) {
        console.error("UDocViewer failed:", err);
        if (!cancelled && onError) onError(err);
      }
    };

    if (src) start();

    return () => {
      cancelled = true;
      try { viewer?.destroy?.(); } catch (e) { /* noop */ }
      try { client?.destroy?.(); } catch (e) { /* noop */ }
    };
  }, [src]);

  return (
    <div
      ref={containerRef}
      style={{ width: "100%", height: "100%", ...style }}
    />
  );
};

export default UDocViewer;
